// extracted by mini-css-extract-plugin
module.exports = {"root":"ConfigBox-root-52ff2c988205367d9bba45a3ab8a6482","title":"ConfigBox-title-45d5d4d4ce0573617a20733934b1b7a2","content":"ConfigBox-content-2e616cf462a31dd1593200adb40f2d16"};